import React from 'react';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

interface RenderMentionsProps {
	content: string;
	taggedUsers: { userId: string; userType: string; name: string }[];
	hashTags: { id: string; title: string }[];
}

const RenderMentions: React.FC<RenderMentionsProps> = ({ content, taggedUsers, hashTags }) => {
	const navigate = useNavigate();
	const handleNavigation = (path: string) => {
		navigate(path);
	};

	const mentionRegex = /@\[(.*?)\]\((\d+|new-[^\)]+)\)/g;
	const hashtagRegex = /#\[(.*?)\]\((\d+|new-[^\)]+)\)|#([^\s]+)/g;

	const findIdByName = (name: string) => {
		const found = hashTags?.find((hashtag) => hashtag.title === name);
		return found ? found.id : null;
	};

	const htmlContent = content
		.replace(mentionRegex, (_, display, id) => {
			const user = taggedUsers?.find((user) => Number(user?.userId) === Number(id));
			const path = user
				? user.userType === 'seeker'
					? `/seeker/profile/${id}`
					: `/company/profile/${id}`
				: '#';
			return `<span class="mention" data-path="${path}" role="link" aria-label="Navigate to ${display} profile">${display}</span>`;
		})
		.replace(hashtagRegex, (_, display, id, plainTag) => {
			const tagName = display || plainTag; // Use display or plain tag if available
			const tagId = id ? id : findIdByName(tagName); // Default ID for plain hashtags

			const path =
				id && id.startsWith('new-')
					? `/hashtag/profile/${hashTags?.find((tag) => tag.title === tagName)?.id || id}`
					: `/hashtag/profile/${tagId}`;

			return `<span class="hashtag" data-path="${path}" role="link" aria-label="Navigate to ${tagName} hashtag">#${tagName}</span>`;
		})
		.replace(/\n/g, '<br>');

	// Handle click events for mentions and hashtags
	const handleClick = (e: React.MouseEvent) => {
		const target = e.target as HTMLElement;
		const path = target.getAttribute('data-path');
		if (path) {
			e.stopPropagation();
			handleNavigation(path);
		}
	};

	return <div onClick={handleClick}>{parse(htmlContent)}</div>;
};

export default RenderMentions;
